namespace GeniuzPOS.AdvPromo {
    export interface PsPromoAvMbForm {
        PmGroupId: Serenity.StringEditor;
        MbType: Serenity.StringEditor;
    }

    export class PsPromoAvMbForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.PsPromoAvMb';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPromoAvMbForm.init)  {
                PsPromoAvMbForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsPromoAvMbForm, [
                    'PmGroupId', w0,
                    'MbType', w0
                ]);
            }
        }
    }
}
